<template>
  <div class="modal-overlay">
    <transition name="modal-expand">
      <div v-if="isVisible" class="logbook-templates-modal" @click.stop>
        <div class="modal-content" @click.stop>
          <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
          <h2>Reset your password</h2>

          <div class="form-group">
            <input
              type="email"
              class="form-control rounded"
              placeholder="Enter your email"
              v-model.trim="email"
              required
            />
          </div>

          <button class="saveButton" style="width: 40%;" :disabled="loading" @click="sendLink">
            {{ loading ? "Sending..." : "Send Reset Link" }}
          </button>

          <p v-if="successMessage" class="mt-3" style="color: green;">{{ successMessage }}</p>

          <div v-if="showAlert" class="alert alert-danger error-message" role="alert">
            <div>{{ errorMessage }}</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      isVisible: false,
      email: "",
      loading: false,
      successMessage: "",
      errorMessage: "",
      showAlert: false,
    };
  },
  mounted() {
    this.isVisible = true;
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async sendLink() {
      this.showAlert = false;
      this.errorMessage = "";
      this.successMessage = "";

      if (!this.email) {
        this.errorMessage = "Please enter your email address.";
        this.showAlert = true;
        return;
      }

      this.loading = true;
      try {
        const res = await axios.post("/api/forgot-password", { email: this.email });

        // Backend returns success even if email doesn't exist
        this.successMessage =
          res.data?.message ||
          "If that email exists, we've sent a password reset link.";

      } catch (err) {
        this.errorMessage =
          err?.response?.data?.message ||
          "Could not send reset email. Please try again.";
        this.showAlert = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
}

.logbook-templates-modal {
    background-color: #fff;
    max-width: min(90%, 900px);
    min-height: 30%;
    min-width: min(80%, 600px);
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
    position: relative;
    display: block;
    z-index: 1001;
    text-align: center;
}

.modal-content {
    position: relative;
    max-height: 90vh;
    overflow-y: auto;
    padding: 15px;
    border: 1px solid #dddddd;
    border-radius: 3px;
}

.saveButton {
    background-color: #0a407a;
    color: #ffffff;
    padding: 10px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-bottom: auto;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    align-self: center;
}

input[type="email"] {
    width: 75%;
    margin-bottom: 15px;
    height: 40px;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

h2 {
    margin-bottom: 1.5rem;
}

.alert-danger {
    color: #ff0019;
    background-color: #f8d7da;
    border: 1px solid #e6b0b6;
}

.alert {
    position: relative;
    padding: .75rem 1.25rem;
    margin-bottom: 0rem;
    border: 1px solid transparent;
    border-radius: .25rem;
}

.form-control.rounded {
  height: 40px;
}

.form-group {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.form-group label {
  width: 160px;
  margin-right: 30px;
  text-align: right;
  margin-bottom: 0px;
}

.form-group input.form-control,
.form-group select.form-control {
  flex: 1;
  width: auto;
  margin-left: 0;
  margin-bottom: 0px;
}
</style>